import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Stagger, itemVariant } from "../components/Reveal";
import { BRANDS } from "../data/content";

export default function Products() {
  const { t, lang, pick } = useLang();
  return (
    <>
      <Seo title="Produkte – TPU, POM, PC, Superabsorber & Tec-Wachs | PlastoNord"
        description="Technisches Kunststoffgranulat von PlastoNord: NORDFLEX® TPU, NORDFORM® POM, NORDLON® PC, NORDSAP® Superabsorber und NORDVAX® Tec-Wachs. Lieferant für Industrie & Verarbeiter."
        path="/produkte"
        breadcrumbs={[{ name: "Home", path: "/" }, { name: "Produkte", path: "/produkte" }]} />
      <PageHero overline={t("nav.products")}
        title={lang === "de" ? "Technisches Kunststoffgranulat für die Industrie" : "Technical plastic granules for industry"}
        subtitle={lang === "de" ? "Fünf Materialfamilien, eine Quelle – mit klarem strategischem Fokus auf TPU." : "Five material families, one source – with a clear strategic focus on TPU."} />
      <section className="py-24">
        <div className="pn-container">
          <Stagger className="grid gap-6 md:grid-cols-2">
            {BRANDS.map((b) => { const c = pick(b); return (
              <motion.div key={b.sku} variants={itemVariant} className={`pn-card p-8 ${b.primary ? "ring-1 ring-[#E2611C] md:col-span-2" : ""}`}>
                <div className="flex flex-wrap items-center gap-3">
                  <span className="font-mono text-xs text-[#E2611C]">{b.material}</span>
                  {b.primary && <span className="rounded-full bg-[#FBEADD] px-3 py-1 text-xs font-semibold text-[#16181D]">{lang === "de" ? "Hauptfokus" : "Main focus"}</span>}
                </div>
                <h2 className="mt-3 font-head text-2xl font-semibold text-[#16181D]">{c.name}</h2>
                <p className="text-[#4a4d52]">{c.tagline}</p>
                <p className="mt-4 max-w-2xl leading-relaxed text-[#4a4d52]">{c.desc}</p>
                <div className="mt-6 flex gap-3">
                  <Link to={b.primary ? "/produkte/nordflex-tpu" : b.href} className="btn-primary !px-5 !py-2 text-sm">{t("cta.more")} <ArrowRight size={15} /></Link>
                  <Link to="/kontakt" className="btn-ghost !px-5 !py-2 text-sm">{t("cta.request")}</Link>
                </div>
              </motion.div>
            ); })}
          </Stagger>
        </div>
      </section>
    </>
  );
}
